import { Grid } from "antd";

//This custom hook is used to get the current screen type
const useScreenType = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  // Returns "mobile", "tablet", or "desktop" based on current screen size
  return screens.xxl || screens.xl
    ? "desktop"
    : screens.lg || screens.md
    ? "tablet"
    : screens.xs || screens.sm
    ? "mobile"
    : "unknown";
};

export default useScreenType;
